import { ComponentButton } from './ComponentButton';
import { BackButton as BackButtonType } from '@/schemas/sceneDataSchema';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const BackButton = ({ component }: { component: BackButtonType }) => {
  const { trackClick } = useAnalytics();

  const onClick = () => {
    trackClick(eventName(component.id), { button_type: component.type });
    return void window.history.back();
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
